import React from "react";

import JoinMeetingByCodeForm from "./JoinMeetingByCodeForm";
import { useGenericComponentsStateService } from "../../Context/GenericComponentsStateContext";

const JoinMeetingModal = () => {
  const { setIsJoinMeetingByCodeOpen } = useGenericComponentsStateService();

  const handleClose = () => {
    setIsJoinMeetingByCodeOpen(false);
  };

  return <JoinMeetingByCodeForm onClose={handleClose} onJoined={handleClose} />;
};

export default JoinMeetingModal;
